import React, { Fragment, useEffect, useState, useRef } from 'react'
import {
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  TabContent,
  Table,
  TabPane
} from 'reactstrap'
import Logo from '../images/greenergy-logo.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faPenToSquare,
  faPrint,
  faDownload,
  faXmark
} from '@fortawesome/free-solid-svg-icons'
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem
} from 'reactstrap'
import '../css/common.css'
import '../css/ClientProfile.css'
import '../css/SalesOrder.css'
import { Link, useParams } from 'react-router-dom'
import { API_URL } from './utils/Constants/URLS'
import PageHeader from './utils/PageHeader'
import EditEnquiryDetails from './Forms/FormComponents/EditLead/EditEnquiryDetails'
import EditSalesOrder from './Forms/FormComponents/EditLead/EditSalesOrder'
import EditProdReq from './Forms/FormComponents/EditLead/EditProductReq'
import EditMarketingPlatform from './Forms/FormComponents/EditLead/EditMarketingPlatform'
import EditWorkingPlatform from './Forms/FormComponents/EditLead/EditWorkingPlatform'
import EditBuyingPlatform from './Forms/FormComponents/EditLead/EditBuyingPlatform'
import ProformaInvoiceModal from './Modals/ProformaInvoiceModal'
import { useSelector } from 'react-redux'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import * as XLSX from 'xlsx'

const LeadProfile = () => {
  const [leadDetails, setLeadDetails] = useState('')
  const [editEnquiryDetails, setEditEnquiryDetails] = useState(false)
  const [editProductRequirement, setEditProductRequirement] = useState(false)
  const [editMarketingPlatform, setEditMarkeingPlatform] = useState(false)
  const [editWorkingPlatform, setEditWorkingPlatform] = useState(false)
  const [editBuyingPlatform, setEditBuyingPlatform] = useState(false)
  const [editSalesOrderPlatform, setEditSalesOrderPlatform] = useState(false)
  const [crossSellData, setCrossSellData] = useState([])
  const [salesOrderData, setSalesOrderData] = useState([])
  const [lpChanges, setLpChanges] = useState({})
  const [activeBtn, setActiveBtn] = useState('Capture Details')
  const token = localStorage.getItem('token')
  const { leadId } = useParams()
  const userDetails = useSelector(store => store.user)
  const [openSO, setOpenSO] = useState() // for accordion toggle
  const [proformaModal, setProformaModal] = useState(false)
  const [proformaOrder, setProformaOrder] = useState(null)
  const [closeSOModal, setCloseSOModal] = useState(false)
  const [closingOrder, setClosingOrder] = useState(null)
  const [closingReason, setClosingReason] = useState('')
  const [closingLoading, setClosingLoading] = useState(false)
  const toggleSO = id => setOpenSO(openSO === id ? undefined : id)
  const pdfRefs = useRef({})

  const handleLPChange = (orderId, lineItemId, value) => {
    setLpChanges(prev => ({
      ...prev,
      [orderId]: {
        ...(prev[orderId] || {}),
        [lineItemId]: value === '' ? '' : Number(value) // allow blank
      }
    }))
  }

  const updateSOTemp = async order => {
    try {
      const orderId = order._id || order.id
      if (!orderId) throw new Error('Sales Order ID missing')

      const lpForOrder = lpChanges[orderId] || {}

      // Build updated lineItems with new LP and recalculated rate & value
      const updatedLineItems = order.lineItems.map(li => {
        const newLP = lpForOrder[li._id]
        if (newLP == null) {
          return li
        }

        const listPrice = Number(newLP)
        const discount = li.discount || 0
        const quantity = li.quantity || 0

        const rate = listPrice * (1 - discount / 100)
        const value = rate * quantity

        return {
          ...li,
          listPrice,
          rate,
          value
        }
      })

      // Build payload based on your sample
      const payload = {
        lead: order.lead?._id || order.lead,
        businessLine: order.businessLine?._id || order.businessLine,
        lineItems: updatedLineItems.map(
          ({
            model,
            quantity,
            listPrice,
            discount,
            rate,
            value,
            standardLeadTime,
            _id
          }) => ({
            model: model?._id || model,
            quantity,
            listPrice,
            discount,
            rate,
            value,
            standardLeadTime,
            _id
          })
        ),
        version: order.version,
        dateOfSO: order.dateOfSO || order.createdAt,
        zeroDateOfDelivery: order.zeroDateOfDelivery,
        customerPONumber: order.customerPONumber,
        customerPODate: order.customerPODate,
        gsplGSTNumber: order.gsplGSTNumber,
        consultant: order.consultant,
        currencyOfTransaction: order.currencyOfTransaction,
        billingAddress: order.billingAddress,
        shippingAddress: order.shippingAddress,
        warrantyPeriod: order.warrantyPeriod,
        paymentTerms: order.paymentTerms?.map(pt => ({
          type: pt.type,
          amount: pt.amount,
          percentage: pt.percentage
        })),
        warrantyTerms: order.warrantyTerms,
        bankGuaranteeDetails: order.bankGuaranteeDetails,
        typeOfTransaction: order.typeOfTransaction,
        responsibilityOfTransportation: order.responsibilityOfTransportation,
        status: order.status,
        priceBasis: order.priceBasis,
        igst: order.igst,
        cgst: order.cgst,
        sgst: order.sgst
      }

      const res = await fetch(`${API_URL}leads/sales-orders/${orderId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      })

      if (!res.ok) {
        const text = await res.text()
        throw new Error(text || 'Failed to update Sales Order')
      }

      const updatedOrder = await res.json()

      // Update local state so UI reflects new data
      setSalesOrderData(prev =>
        prev.map(o => (o._id === updatedOrder._id ? updatedOrder : o))
      )

      // Clear LP edits for this order
      setLpChanges(prev => {
        const copy = { ...prev }
        delete copy[orderId]
        return copy
      })

      window.alert('Sales Order LP updated successfully')
      window.location.reload()
    } catch (err) {
      console.error(err)
      window.alert(err.message || 'Something went wrong while updating LP')
    }
  }

  const handleCloseSalesOrder = async () => {
    if (!closingReason.trim()) {
      window.alert('Please provide a closing reason.')
      return
    }
    try {
      setClosingLoading(true)
      const res = await fetch(
        `${API_URL}leads/sales-orders/${closingOrder._id}/close`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ closingReason: closingReason.trim() })
        }
      )
      const data = await res.json()
      if (!res.ok || data.error) {
        throw new Error(data.message || 'Failed to close Sales Order')
      }
      window.alert('Sales Order closed successfully.')
      setCloseSOModal(false)
      setClosingReason('')
      setClosingOrder(null)
      window.location.reload()
    } catch (err) {
      console.error(err)
      window.alert(err.message || 'Something went wrong while closing the Sales Order')
    } finally {
      setClosingLoading(false)
    }
  }

  const handleDownloadPDF = order => {
    const doc = new jsPDF({ orientation: 'landscape' })
    const pageWidth = doc.internal.pageSize.getWidth()
    const pageHeight = doc.internal.pageSize.getHeight()

    // 1️⃣ Logo at center
    const imgWidth = 55
    const imgHeight = 10
    doc.addImage(
      Logo,
      'PNG',
      (pageWidth - imgWidth) / 2,
      10,
      imgWidth,
      imgHeight
    )

    let y = 35
    const leftX = 14
    const rightX = 150
    const maxFieldWidth = 90

    // 🔧 Helper function: bold label + normal value, with wrapping and dynamic height
    const addLabelValue = (label, value, x, y, maxWidth = maxFieldWidth) => {
      doc.setFont('helvetica', 'bold')
      doc.text(`${label}:`, x, y)
      const labelWidth = doc.getTextWidth(`${label}: `)

      doc.setFont('helvetica', 'normal')
      const splitText = doc.splitTextToSize(value || '-', maxWidth - labelWidth)
      doc.text(splitText, x + labelWidth, y)

      return y + (splitText.length - 1) * 5 + 6 // return updated y
    }

    // 2️⃣ Order Info - row by row, tracking y
    doc.setFontSize(10)
    y = addLabelValue(
      'Sales Order Number',
      order.salesOrderNumber || '-',
      leftX,
      y
    )
    y = addLabelValue(
      'Business Line',
      order.businessLine?.name || '-',
      rightX,
      y
    )

    y = addLabelValue('Lead No', order.lead?.leadId || '-', leftX, y)
    y = addLabelValue(
      'Sales Executive',
      order.lead?.leadOwner?.name || '-',
      rightX,
      y
    )

    y = addLabelValue(
      'Customer Name',
      order.lead?.client?.companyName || '-',
      leftX,
      y
    )
    y = addLabelValue(
      'Date of SO',
      new Date(order.createdAt).toLocaleDateString('en-GB'),
      rightX,
      y
    )

    y = addLabelValue(
      'Zero Date Delivery',
      order.zeroDateOfDelivery || '-',
      leftX,
      y
    )
    y = addLabelValue(
      'Customer PO No',
      order.customerPONumber || '-',
      rightX,
      y
    )

    y = addLabelValue(
      'Customer PO Date',
      order.customerPODate?.substring(0, 10) || '-',
      leftX,
      y
    )
    y = addLabelValue('GSPL GSTIN', order.gsplGSTNumber || '-', rightX, y)

    y = addLabelValue('Consultant', order.consultant || '-', leftX, y)
    y = addLabelValue('Currency', order.currencyOfTransaction || '-', rightX, y)

    y = addLabelValue('Warranty Period', order.warrantyPeriod || '-', leftX, y)
    y = addLabelValue('Billing Address', order.billingAddress || '-', rightX, y)

    y = addLabelValue(
      'Shipping Address',
      order.shippingAddress || '-',
      leftX,
      y
    )
    y += 10

    // 3️⃣ Line Items Table
    autoTable(doc, {
      startY: y,
      head: [
        [
          'SI',
          'Name',
          'Part Code',
          'UOM',
          'Qty',
          'Std. Lead Time',
          'Date',
          'LP',
          'Discount%',
          'Rate Per Unit',
          'Order Value'
        ]
      ],
      body: order.lineItems.map((item, idx) => [
        idx + 1,
        item.model?.modelName || '',
        item.model?.partCode || '',
        item.model?.uom || '',
        item.quantity || '',
        item.standardLeadTime || '',
        item.committedDeliveryDate?.substring(0, 10) || '',
        (item.listPrice || 0).toFixed(2),
        (item.discount || 0).toFixed(2),
        (item.rate || 0).toFixed(2),
        (item.value || 0).toFixed(2)
      ]),
      theme: 'grid',
      styles: {
        fontSize: 8,
        cellPadding: 2,
        overflow: 'linebreak',
        cellWidth: 'wrap'
      },
      headStyles: {
        fillColor: [230, 230, 230],
        textColor: [0, 0, 0],
        fontSize: 8,
        fontStyle: 'bold'
      },
      columnStyles: {
        0: { cellWidth: 12, halign: 'center' },
        1: { cellWidth: 35, halign: 'left' },
        2: { cellWidth: 35, halign: 'left' },
        3: { cellWidth: 15, halign: 'center' },
        4: { cellWidth: 20, halign: 'center' },
        5: { cellWidth: 22, halign: 'center' },
        6: { cellWidth: 18, halign: 'right' },
        7: { cellWidth: 18, halign: 'right' },
        8: { cellWidth: 20, halign: 'right' },
        9: { cellWidth: 20, halign: 'right' }
      },
      margin: { left: 14, right: 14 }
    })

    let finalY = doc.lastAutoTable.finalY + 10

    if (finalY > pageHeight - 50) {
      doc.addPage()
      finalY = 20
    }

    // 4️⃣ Payment Terms Table
    const totalValue = order.lineItems.reduce(
      (acc, item) => acc + (item.value || 0),
      0
    )

    autoTable(doc, {
      startY: finalY,
      head: [['Payment Term', 'Percentage', 'Amount']],
      body: order.paymentTerms.map(term => [
        term.type || '-',
        totalValue ? `${((term.amount / totalValue) * 100).toFixed(2)}%` : '0%',
        (term.amount || 0).toFixed(2)
      ]),
      theme: 'grid',
      styles: { fontSize: 9, cellPadding: 3 },
      headStyles: {
        fillColor: [240, 240, 240],
        textColor: [0, 0, 0],
        fontStyle: 'bold'
      },
      columnStyles: {
        0: { cellWidth: 120, halign: 'left' },
        1: { cellWidth: 30, halign: 'center' },
        2: { cellWidth: 35, halign: 'right' }
      },
      margin: { left: 14, right: 14 }
    })

    finalY = doc.lastAutoTable.finalY + 10
    if (finalY > pageHeight - 50) {
      doc.addPage()
      finalY = 20
    }

    // 5️⃣ Commercial Info Table
    autoTable(doc, {
      startY: finalY,
      body: [
        ['Price Basis:', order.priceBasis || '-'],
        [
          'Responsibility of Transportation:',
          order.responsibilityOfTransportation || '-'
        ],
        ['Type of Transaction:', order.typeOfTransaction || '-'],
        ['GST Details:', `GST extra as applicable`],
        ['Bank Guarantee:', order.bankGuaranteeDetails || '-'],
        ['Warranty Terms:', order.warrantyTerms || '-']
      ],
      theme: 'plain',
      styles: {
        fontSize: 9,
        cellPadding: 3,
        overflow: 'linebreak'
      },
      columnStyles: {
        0: { cellWidth: 60, halign: 'left', fontStyle: 'bold' },
        1: { cellWidth: 180, halign: 'left' }
      },
      margin: { left: 14, right: 14 },
      didParseCell: function (data) {
        if (data.section === 'body' && data.column.index === 0) {
          data.cell.styles.fontStyle = 'bold'
        }
      }
    })

    // 6️⃣ Save the PDF
    try {
      doc.save(`sales-order-${order.salesOrderNumber || 'SO'}.pdf`)
    } catch (error) {
      console.error('Error generating PDF:', error)
      alert('Error generating PDF. Please try again.')
    }
  }

  // ─── Proforma Invoice PDF ────────────────────────────────────────────────
  const handleDownloadProformaPDF = async order => {
    const soId = order._id || order.id
    if (!soId) return

    let piList = []
    try {
      const res = await fetch(`${API_URL}proforma-invoices/by-sales-order/${soId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })
      const json = await res.json()
      piList = Array.isArray(json?.data) ? json.data : []
    } catch (err) {
      console.error('Failed to fetch PI:', err)
      alert('Could not fetch Proforma Invoice data.')
      return
    }

    if (piList.length === 0) {
      alert('No Proforma Invoice found for this Sales Order.')
      return
    }

    // Generate one PDF file containing all PIs for this SO
    const { jsPDF } = await import('jspdf')
    const html2canvas = (await import('html2canvas')).default

    const pdf = new jsPDF('p', 'mm', 'a4')
    const pageWidth = 210
    const pageHeight = 297
    const margin = 5
    let firstPage = true

    const money = n =>
      (Number(n) || 0).toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })

    const numberToWords = num => {
      const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine']
      const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen']
      const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety']
      const cvt = n => {
        if (n === 0) return ''
        if (n < 10) return ones[n]
        if (n < 20) return teens[n - 10]
        if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? ' ' + ones[n % 10] : '')
        return ones[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' ' + cvt(n % 100) : '')
      }
      const rupees = Math.floor(num)
      const paise = Math.round((num - rupees) * 100)
      const cr = Math.floor(rupees / 10000000)
      const lk = Math.floor((rupees % 10000000) / 100000)
      const th = Math.floor((rupees % 100000) / 1000)
      const hn = rupees % 1000
      let r = ''
      if (cr) r += cvt(cr) + ' Crore '
      if (lk) r += cvt(lk) + ' Lakh '
      if (th) r += cvt(th) + ' Thousand '
      if (hn) r += cvt(hn)
      let out = (r.trim() || 'Zero') + ' Rupees'
      if (paise) out += ' and ' + cvt(paise) + ' Paise'
      return out + ' Only'
    }

    const formatDate = d => {
      if (!d) return '-'
      const dt = new Date(d)
      if (isNaN(dt)) return '-'
      return dt.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
    }

    const container = document.createElement('div')
    container.style.cssText = 'position:absolute;left:-9999px;top:0;width:794px;padding:0;margin:0;background:white;box-sizing:border-box;'
    document.body.appendChild(container)

    try {
      for (let piIdx = 0; piIdx < piList.length; piIdx++) {
        const pi = piList[piIdx]
        const lineItems = Array.isArray(pi.lineItems) ? pi.lineItems : []
        const paymentTerms = Array.isArray(pi.paymentTerms) ? pi.paymentTerms : []
        const seller = pi.salesOrder || {}
        const client = pi.client || {}
        const soData = pi.salesOrder || {}

        // Determine GST category
        const isIGST = soData.typeOfTransaction === 'Export' || soData.typeOfTransaction === 'SEZ'

        // Totals
        const subTotal = lineItems.reduce((sum, it) => sum + (Number(it.value) || 0), 0)
        const hasDiscount = lineItems.some(it => Number(it.discount || 0) > 0)

        // Group by HSN for GST breakup
        const groupedByHsn = lineItems.reduce((acc, it) => {
          const hsn = it.model?.HSNNumber || it.model?.hsnCode || '-'
          const gstRate = Number(it.gst || 0)
          const taxableValue = Number(it.value || 0)
          const cgstAmt = isIGST ? 0 : taxableValue * (gstRate / 2) / 100
          const sgstAmt = isIGST ? 0 : taxableValue * (gstRate / 2) / 100
          const igstAmt = isIGST ? taxableValue * gstRate / 100 : 0
          if (!acc[hsn]) acc[hsn] = { hsnCode: hsn, taxableValue: 0, cgstAmt: 0, sgstAmt: 0, igstAmt: 0, gstRate }
          acc[hsn].taxableValue += taxableValue
          acc[hsn].cgstAmt += cgstAmt
          acc[hsn].sgstAmt += sgstAmt
          acc[hsn].igstAmt += igstAmt
          return acc
        }, {})
        const hsnGroups = Object.values(groupedByHsn)

        const totalTax = isIGST
          ? hsnGroups.reduce((s, g) => s + g.igstAmt, 0)
          : hsnGroups.reduce((s, g) => s + g.cgstAmt + g.sgstAmt, 0)
        const netTotal = subTotal + totalTax

        // Build primary address strings for buyer
        const primaryAddr = Array.isArray(client.address) && client.address.length > 0
          ? client.address[0] : {}
        const billingAdd = [
          primaryAddr.addressLine1,
          primaryAddr.addressLine2,
          primaryAddr.city,
          primaryAddr.state,
          primaryAddr.country
        ].filter(Boolean).join(', ')
        const billingPin = primaryAddr.pincode || '-'

        // Seller GSTIN determines seller address
        const gstin = soData.gsplGSTNumber || '-'
        const sellerAddr = gstin.startsWith('19')
          ? { line1: 'Block C, 1st Floor, PCM Bus Terminus & Commercial Complex, 2nd Mile, Sevoke Road, Siliguri', state: 'West Bengal', pin: '734001' }
          : { line1: 'Baliram Path, Bylane No 4, Garchuk, Mouza-Jalukbari, Guwahati', state: 'Assam', pin: '781035' }

        const itemsPerPage = 15
        const totalPages = Math.max(1, Math.ceil(lineItems.length / itemsPerPage))

        for (let pageNum = 0; pageNum < totalPages; pageNum++) {
          const startIdx = pageNum * itemsPerPage
          const endIdx = Math.min(startIdx + itemsPerPage, lineItems.length)
          const pageItems = lineItems.slice(startIdx, endIdx)
          const isLastPage = pageNum === totalPages - 1

          const pageHTML = `
<div style="font-family:Arial;width:100%;background:white;padding:0;margin:0;box-sizing:border-box;">
  <div style="border:1px solid #000;background:white;">
    <!-- Title -->
    <div style="text-align:center;padding:10px 20px;border-bottom:1px solid #000">
      <h2 style="margin:5px 0">Proforma Invoice</h2>
    </div>

    <!-- Seller / Invoice Details -->
    <div style="display:flex;border-bottom:1px solid #000">
      <div style="width:40%;padding:8px;border-right:1px solid #000">
        <div style="font-size:13px;font-weight:bold">Greenergy Solution Private Limited</div>
        <div style="font-size:12px">${sellerAddr.line1}</div>
        <div style="font-size:12px">${sellerAddr.state} - ${sellerAddr.pin}</div>
        <div style="font-size:12px">GSTIN: ${gstin}</div>
        <div style="font-size:12px">CIN: U74140WB2011PTC159722</div>
        <div style="font-size:12px">UDYAM Reg: UDYAM-WB-09-0000238</div>
      </div>
      <div style="width:60%;padding:8px">
        <table style="width:100%;border-collapse:collapse">
          <tr><td style="font-weight:bold;padding:2px 4px;font-size:12px">PI No</td><td style="padding:2px 4px;font-size:12px">${pi.piNo || '-'}</td></tr>
          <tr><td style="font-weight:bold;padding:2px 4px;font-size:12px">PI Date</td><td style="padding:2px 4px;font-size:12px">${formatDate(pi.createdAt)}</td></tr>
          <tr><td style="font-weight:bold;padding:2px 4px;font-size:12px">Customer PO No.</td><td style="padding:2px 4px;font-size:12px">${pi.purchaseOrderNo || soData.customerPONumber || '-'}</td></tr>
          <tr><td style="font-weight:bold;padding:2px 4px;font-size:12px">Customer PO Date</td><td style="padding:2px 4px;font-size:12px">${formatDate(pi.purchaseOrderDate || soData.customerPODate)}</td></tr>
          <tr><td style="font-weight:bold;padding:2px 4px;font-size:12px">SO No.</td><td style="padding:2px 4px;font-size:12px">${soData.salesOrderNumber || '-'}</td></tr>
          <tr><td style="font-weight:bold;padding:2px 4px;font-size:12px">Price Basis</td><td style="padding:2px 4px;font-size:12px">${soData.priceBasis || '-'}</td></tr>
          <tr><td style="font-weight:bold;padding:2px 4px;font-size:12px">Delivery Note</td><td style="padding:2px 4px;font-size:12px">${pi.deliveryNote || '-'}</td></tr>
          <tr><td style="font-weight:bold;padding:2px 4px;font-size:12px">Dispatch Through</td><td style="padding:2px 4px;font-size:12px">${pi.dispatchThrough || '-'}</td></tr>
          <tr><td style="font-weight:bold;padding:2px 4px;font-size:12px">Destination</td><td style="padding:2px 4px;font-size:12px">${pi.destination || '-'}</td></tr>
          <tr><td style="font-weight:bold;padding:2px 4px;font-size:12px">Other References</td><td style="padding:2px 4px;font-size:12px">${pi.otherReference || '-'}</td></tr>
        </table>
      </div>
    </div>

    <!-- Bill To / Ship To -->
    <div style="display:flex;border-bottom:1px solid #000">
      <div style="width:50%;padding:8px">
        <div style="font-size:12px;font-weight:bold">Billing Address</div>
        <div style="font-size:12px">${client.companyName || '-'}</div>
        <div style="font-size:12px">${billingAdd || '-'}</div>
        <div style="font-size:12px">Pin - ${billingPin}</div>
        <div style="font-size:12px">GSTIN: ${client.gstNumber || '-'}</div>
      </div>
      <div style="width:50%;padding:8px;border-left:1px solid #000">
        <div style="font-size:12px;font-weight:bold">Shipping Address</div>
        <div style="font-size:12px">${pi.destination || soData.shippingAddress || '-'}</div>
      </div>
    </div>
  </div>

  <!-- Line Items Table -->
  <div style="border:1px solid #000;border-top:none;padding:0;margin:0">
    <table style="width:100%;border-collapse:collapse">
      <thead>
        <tr>
          <th style="padding:6px;font-size:11px;text-align:center;border-right:1px solid #000;border-bottom:1px solid #000">Sl</th>
          <th style="padding:6px;font-size:11px;text-align:left;border-right:1px solid #000;border-bottom:1px solid #000">Description</th>
          <th style="padding:6px;font-size:11px;text-align:center;border-right:1px solid #000;border-bottom:1px solid #000">UOM</th>
          <th style="padding:6px;font-size:11px;text-align:center;border-right:1px solid #000;border-bottom:1px solid #000">Part Code</th>
          <th style="padding:6px;font-size:11px;text-align:center;border-right:1px solid #000;border-bottom:1px solid #000">HSN</th>
          <th style="padding:6px;font-size:11px;text-align:center;border-right:1px solid #000;border-bottom:1px solid #000">GST%</th>
          <th style="padding:6px;font-size:11px;text-align:center;border-right:1px solid #000;border-bottom:1px solid #000">Qty</th>
          <th style="padding:6px;font-size:11px;text-align:right;border-right:1px solid #000;border-bottom:1px solid #000">Rate</th>
          ${hasDiscount ? '<th style="padding:6px;font-size:11px;text-align:right;border-right:1px solid #000;border-bottom:1px solid #000">Disc%</th>' : ''}
          <th style="padding:6px;font-size:11px;text-align:right;border-bottom:1px solid #000">Amount</th>
        </tr>
      </thead>
      <tbody>
        ${pageItems.map((it, idx) => {
            const gIdx = startIdx + idx
            const modelName = it.model?.modelName || '-'
            const partCode = it.model?.partCode || '-'
            const hsn = it.model?.HSNNumber || it.model?.hsnCode || '-'
            const uom = it.model?.uom || '-'
            const productName = it.narration ? `${modelName} <br/>(${it.narration})` : modelName
            return `<tr style="${idx === pageItems.length - 1 ? "border-bottom:1px solid #000;" : ""}">
            <td style="padding:4px;font-size:11px;text-align:center;border-right:1px solid #000">${gIdx + 1}</td>
            <td style="padding:4px;font-size:11px;border-right:1px solid #000">${productName}</td>
            <td style="padding:4px;font-size:11px;text-align:center;border-right:1px solid #000">${uom}</td>
            <td style="padding:4px;font-size:11px;text-align:center;border-right:1px solid #000">${partCode}</td>
            <td style="padding:4px;font-size:11px;text-align:center;border-right:1px solid #000">${hsn}</td>
            <td style="padding:4px;font-size:11px;text-align:center;border-right:1px solid #000">${it.gst || 0}%</td>
            <td style="padding:4px;font-size:11px;text-align:center;border-right:1px solid #000">${it.quantity || 0}</td>
            <td style="padding:4px;font-size:11px;text-align:right;border-right:1px solid #000">${money(it.listPrice)}</td>
            ${hasDiscount ? `<td style="padding:4px;font-size:11px;text-align:right;border-right:1px solid #000">${it.discount || 0}%</td>` : ''}
            <td style="padding:4px;font-size:11px;text-align:right">${money(it.value)}</td>
          </tr>`
          }).join('')}
        ${isLastPage ? `
        <tr><td colspan="${hasDiscount ? 9 : 8}" style="padding:4px;font-size:11px;text-align:right;font-weight:bold;border-top:1px solid #000">Subtotal</td><td style="padding:4px;font-size:11px;text-align:right;border-top:1px solid #000;font-weight:bold">${money(subTotal)}</td></tr>
        ${isIGST
                ? `<tr><td colspan="${hasDiscount ? 9 : 8}" style="padding:4px;font-size:11px;text-align:right;font-weight:bold">IGST</td><td style="padding:4px;font-size:11px;text-align:right;font-weight:bold">${money(hsnGroups.reduce((s, g) => s + g.igstAmt, 0))}</td></tr>`
                : `<tr><td colspan="${hasDiscount ? 9 : 8}" style="padding:4px;font-size:11px;text-align:right;font-weight:bold">CGST</td><td style="padding:4px;font-size:11px;text-align:right;font-weight:bold">${money(hsnGroups.reduce((s, g) => s + g.cgstAmt, 0))}</td></tr>
               <tr><td colspan="${hasDiscount ? 9 : 8}" style="padding:4px;font-size:11px;text-align:right;font-weight:bold">SGST</td><td style="padding:4px;font-size:11px;text-align:right;font-weight:bold">${money(hsnGroups.reduce((s, g) => s + g.sgstAmt, 0))}</td></tr>`
              }
        <tr><td colspan="${hasDiscount ? 9 : 8}" style="padding:4px;font-size:11px;text-align:right;font-weight:bold">Net Total</td><td style="padding:4px;font-size:11px;text-align:right;font-weight:bold">${money(Math.round(netTotal))}</td></tr>
        <tr><td colspan="${hasDiscount ? 10 : 9}" style="padding:6px;font-size:11px;font-style:italic"><b>${numberToWords(Math.round(netTotal))}</b></td></tr>
        ` : ''}
      </tbody>
    </table>
  </div>

  ${isLastPage ? `
  <!-- Payment Terms with running balance -->
  <div style="border:1px solid #000;border-top:none;padding:0;margin:0">
    <table style="width:100%;border-collapse:collapse">
      <tr>
        <th style="padding:4px;font-size:11px;border-bottom:1px solid #000;border-bottom:1px solid #000;text-align:left">Term</th>
        <th style="padding:4px;font-size:11px;border-bottom:1px solid #000;border-bottom:1px solid #000;text-align:center">Percentage%</th>
        <th style="padding:4px;font-size:11px;border-bottom:1px solid #000;border-bottom:1px solid #000;text-align:right">Amount (₹)</th>
        <th style="padding:4px;font-size:11px;border-bottom:1px solid #000;border-bottom:1px solid #000;text-align:right">Balance (₹)</th>
      </tr>
      ${(() => {
                let balance = Math.round(netTotal)
                return paymentTerms.map((pt, idx) => {
                  const amt = Number(pt.amount || 0)
                  if (pt.action === 'less') balance -= amt
                  else if (pt.action === 'add') balance += amt
                  // 'display' → no change to balance
                  return `<tr style="${idx === paymentTerms.length - 1 ? "border-bottom:1px solid #000;" : ""}">
            <td style="padding:4px;font-size:11px;border-right:1px solid #000">${pt.action !== 'display' ? pt.action.toUpperCase() + ': ' + pt.type : pt.type || '-'}</td>
            <td style="padding:4px;font-size:11px;border-right:1px solid #000;text-align:center">${pt.percentage || 0}%</td>
            <td style="padding:4px;font-size:11px;border-right:1px solid #000;text-align:right">${money(amt)}</td>
            <td style="padding:4px;font-size:11px;border-right:1px solid #000;text-align:right;font-weight:bold">${money(balance)}</td>
          </tr>`
                }).join('')
              })()}
      <tr style="background:#f5f5f5">
        <td colspan="3" style="padding-bottom:4px;font-size:12px;border:1px solid #ccc;text-align:right;font-weight:bold">Net Payable</td>
        <td style="padding:4px;font-size:11px;border:1px solid #ccc;text-align:left;font-style:italic">${(() => {
                let bal = Math.round(netTotal)
                paymentTerms.forEach(pt => {
                  const amt = Number(pt.amount || 0)
                  if (pt.action === 'less') bal -= amt
                  else if (pt.action === 'add') bal += amt
                  // 'display' → no change to balance
                })
                return numberToWords(bal)
              })()}</td>
      </tr>
    </table>
  </div>

  <!-- GST Breakup -->
  <div style="border:1px solid #000;border-top:none;padding:8px">
    ${isIGST ? `
    <table border="1" style="width:100%;border-collapse:collapse">
      <tr><th style="padding:4px;font-size:11px">HSN/SAC</th><th style="padding:4px;font-size:11px">Taxable Value</th><th style="padding:4px;font-size:11px">IGST Rate</th><th style="padding:4px;font-size:11px">IGST Amt</th><th style="padding:4px;font-size:11px">Total Tax</th></tr>
      ${hsnGroups.map(g => `<tr><td style="padding:4px;font-size:11px">${g.hsnCode}</td><td style="padding:4px;font-size:11px">${money(g.taxableValue)}</td><td style="padding:4px;font-size:11px">${g.gstRate}%</td><td style="padding:4px;font-size:11px">${money(g.igstAmt)}</td><td style="padding:4px;font-size:11px">${money(g.igstAmt)}</td></tr>`).join('')}
      <tr style="font-weight:bold"><td style="padding:4px;font-size:11px">Total</td><td style="padding:4px;font-size:11px">${money(hsnGroups.reduce((s, g) => s + g.taxableValue, 0))}</td><td></td><td style="padding:4px;font-size:11px">${money(hsnGroups.reduce((s, g) => s + g.igstAmt, 0))}</td><td style="padding:4px;font-size:11px">${money(hsnGroups.reduce((s, g) => s + g.igstAmt, 0))}</td></tr>
    </table>` : `
    <table border="1" style="width:100%;border-collapse:collapse">
      <tr><th style="padding:4px;font-size:11px">HSN/SAC</th><th style="padding:4px;font-size:11px">Taxable Value</th><th style="padding:4px;font-size:11px">CGST Rate</th><th style="padding:4px;font-size:11px">CGST Amt</th><th style="padding:4px;font-size:11px">SGST Rate</th><th style="padding:4px;font-size:11px">SGST Amt</th><th style="padding:4px;font-size:11px">Total Tax</th></tr>
      ${hsnGroups.map(g => `<tr><td style="padding:4px;font-size:11px">${g.hsnCode}</td><td style="padding:4px;font-size:11px">${money(g.taxableValue)}</td><td style="padding:4px;font-size:11px">${g.gstRate / 2}%</td><td style="padding:4px;font-size:11px">${money(g.cgstAmt)}</td><td style="padding:4px;font-size:11px">${g.gstRate / 2}%</td><td style="padding:4px;font-size:11px">${money(g.sgstAmt)}</td><td style="padding:4px;font-size:11px">${money(g.cgstAmt + g.sgstAmt)}</td></tr>`).join('')}
      <tr style="font-weight:bold"><td style="padding:4px;font-size:11px">Total</td><td style="padding:4px;font-size:11px">${money(hsnGroups.reduce((s, g) => s + g.taxableValue, 0))}</td><td></td><td style="padding:4px;font-size:11px">${money(hsnGroups.reduce((s, g) => s + g.cgstAmt, 0))}</td><td></td><td style="padding:4px;font-size:11px">${money(hsnGroups.reduce((s, g) => s + g.sgstAmt, 0))}</td><td style="padding:4px;font-size:11px">${money(hsnGroups.reduce((s, g) => s + g.cgstAmt + g.sgstAmt, 0))}</td></tr>
    </table>`}
  </div>

  <!-- Declaration + Bank -->
  <div style="border:1px solid #000;border-top:none;padding:8px;display:flex;justify-content:space-between">
    <div style="width:48%;border-right:1px solid #000;padding-right:10px">
      <b style="font-size:12px">Declaration</b><br/>
      <span style="font-size:12px">We declare that this proforma invoice shows the actual price of the goods described and that all particulars are true and correct.</span>
    </div>
    <div style="width:48%;padding-left:10px">
      <b style="font-size:12px">Company's Bank Details</b><br/>
      <span style="font-size:12px">Bank Name: <b>HDFC Bank C/C</b></span><br/>
      <span style="font-size:12px">A/C No: <b>50200013650542</b></span><br/>
      <span style="font-size:12px">Branch &amp; IFSC: <b>Sevoke Road Branch &amp; HDFC0000151</b></span>
    </div>
  </div>

  <!-- Signatures -->
  <div style="border:1px solid #000;border-top:none;padding:12px 8px;display:flex;justify-content:space-between">
    <div style="font-size:12px">Customer Seal and Signature</div>
    <div style="text-align:right;font-size:12px">Authorised Signatory</div>
  </div>
  ` : ''}
</div>`

          container.innerHTML = pageHTML

          const canvas = await html2canvas(container, {
            scale: 2,
            useCORS: true,
            logging: false,
            backgroundColor: '#ffffff'
          })

          if (!firstPage) pdf.addPage()
          firstPage = false

          const imgData = canvas.toDataURL('image/jpeg', 1.0)
          const imgWidth = pageWidth - 2 * margin
          let imgHeight = (canvas.height * imgWidth) / canvas.width
          const maxH = pageHeight - 2 * margin
          if (imgHeight > maxH) imgHeight = maxH
          pdf.addImage(imgData, 'JPEG', margin, margin, imgWidth, imgHeight)
        }
      }

      pdf.save(`proforma-${piList[0]?.piNo || soId}.pdf`)
    } finally {
      document.body.removeChild(container)
    }
  }

  const handleDownloadExcel = (order) => {
    try {
      const wb = XLSX.utils.book_new()
      const rows = []

      const bold = (v) => ({ v, s: { font: { bold: true } } })
      const header = (v) => ({ v, s: { font: { bold: true }, fill: { fgColor: { rgb: 'E6E6E6' } }, alignment: { horizontal: 'center' } } })
      const right = (v) => ({ v, s: { alignment: { horizontal: 'right' } } })

      // ─── 1. ORDER INFO (two columns side by side, matching PDF layout) ───────
      const info = [
        ['Sales Order Number', order.salesOrderNumber || '-', 'Lead No', order.lead?.leadId || '-'],
        ['Business Line', order.businessLine?.name || '-', 'Sales Executive', order.lead?.leadOwner?.name || '-'],
        ['Customer Name', order.lead?.client?.companyName || '-', 'Date of SO', new Date(order.createdAt).toLocaleDateString('en-GB')],
        ['Zero Date Delivery', order.zeroDateOfDelivery || '-', 'Customer PO No', order.customerPONumber || '-'],
        ['Customer PO Date', order.customerPODate?.substring(0, 10) || '-', 'GSPL GSTIN', order.gsplGSTNumber || '-'],
        ['Consultant', order.consultant || '-', 'Currency', order.currencyOfTransaction || '-'],
        ['Warranty Period', order.warrantyPeriod || '-', 'Billing Address', order.billingAddress || '-'],
        ['Shipping Address', order.shippingAddress || '-', '', ''],
      ]

      info.forEach(([l1, v1, l2, v2]) => {
        rows.push([bold(l1), v1, '', bold(l2), v2])
      })

      // ─── 2. SPACER ───────────────────────────────────────────────────────────
      rows.push([])

      // ─── 3. LINE ITEMS TABLE ─────────────────────────────────────────────────
      rows.push([
        header('SI'), header('Name'), header('Part Code'), header('UOM'), header('Qty'),
        header('Std. Lead Time'), header('Committed Delivery Date'),
        header('List Price'), header('Discount %'), header('Rate Per Unit'), header('Order Value'),
      ])

      order.lineItems.forEach((item, idx) => {
        rows.push([
          idx + 1,
          item.model?.modelName || '',
          item.model?.partCode || '',
          item.model?.uom || '',
          item.quantity || '',
          item.standardLeadTime || '',
          item.committedDeliveryDate?.substring(0, 10) || '',
          right(parseFloat((item.listPrice || 0).toFixed(2))),
          right(parseFloat((item.discount || 0).toFixed(2))),
          right(parseFloat((item.rate || 0).toFixed(2))),
          right(parseFloat((item.value || 0).toFixed(2))),
        ])
      })

      const totalValue = order.lineItems.reduce((acc, item) => acc + (item.value || 0), 0)
      rows.push([
        '', '', '', '', '', '', bold('TOTAL'),
        '', '', '',
        { v: parseFloat(totalValue.toFixed(2)), s: { font: { bold: true }, alignment: { horizontal: 'right' } } },
      ])

      // ─── 4. SPACER ───────────────────────────────────────────────────────────
      rows.push([])

      // ─── 5. PAYMENT TERMS TABLE ──────────────────────────────────────────────
      rows.push([header('Payment Term'), header('Percentage'), header('Amount')])

      order.paymentTerms.forEach(term => {
        rows.push([
          term.type || '-',
          right(totalValue ? parseFloat(((term.amount / totalValue) * 100).toFixed(2)) : 0),
          right(parseFloat((term.amount || 0).toFixed(2))),
        ])
      })

      const totalAmt = order.paymentTerms.reduce((acc, t) => acc + (t.amount || 0), 0)
      const totalPct = totalValue ? parseFloat(((totalAmt / totalValue) * 100).toFixed(2)) : 0
      rows.push([
        bold('TOTAL'),
        { v: totalPct, s: { font: { bold: true }, alignment: { horizontal: 'right' } } },
        { v: parseFloat(totalAmt.toFixed(2)), s: { font: { bold: true }, alignment: { horizontal: 'right' } } },
      ])

      // ─── 6. SPACER ───────────────────────────────────────────────────────────
      rows.push([])

      // ─── 7. COMMERCIAL INFO ──────────────────────────────────────────────────
      const commercial = [
        ['Price Basis', order.priceBasis || '-'],
        ['Responsibility of Transportation', order.responsibilityOfTransportation || '-'],
        ['Type of Transaction', order.typeOfTransaction || '-'],
        ['GST Details', 'GST extra as applicable'],
        ['Bank Guarantee', order.bankGuaranteeDetails || '-'],
        ['Warranty Terms', order.warrantyTerms || '-'],
      ]

      commercial.forEach(([label, value]) => {
        rows.push([bold(label), value])
      })

      // ─── 8. BUILD SHEET ──────────────────────────────────────────────────────
      const ws = XLSX.utils.aoa_to_sheet(rows)

      ws['!cols'] = [
        { wch: 28 }, // A - label col 1
        { wch: 35 }, // B - value col 1
        { wch: 4 }, // C - spacer between info pairs
        { wch: 28 }, // D - label col 2
        { wch: 35 }, // E - value col 2
        { wch: 16 }, // F - Std. Lead Time
        { wch: 22 }, // G - Committed Delivery Date
        { wch: 14 }, // H - List Price
        { wch: 12 }, // I - Discount %
        { wch: 16 }, // J - Rate Per Unit
        { wch: 14 }, // K - Order Value
      ]

      XLSX.utils.book_append_sheet(wb, ws, 'Sales Order')

      // ─── 9. SAVE ─────────────────────────────────────────────────────────────
      XLSX.writeFile(wb, `sales-order-${order.salesOrderNumber || 'SO'}.xlsx`)
    } catch (error) {
      console.error('Error generating Excel:', error)
      alert('Error generating Excel. Please try again.')
    }
  }

  useEffect(() => {
    const getLeadDetails = async () => {
      const url = `${API_URL}leads/${leadId}`

      const data = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })

      const result = await data.json()
      setLeadDetails(result.data)
    }
    getLeadDetails()
    getSalesOrder()
    getCrossSellData()
  }, [leadId, token])

  const getSalesOrder = async () => {
    const url = `${API_URL}leads/${leadId}/sales-orders`

    const data = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })

    const result = await data.json()
    setSalesOrderData(result?.data)
  }

  const downloadPo = async filePath => {
    try {
      const url = `${API_URL}file/serve`

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ filePath })
      })

      if (!response.ok) return

      const blob = await response.blob()
      const downloadUrl = window.URL.createObjectURL(blob)

      const a = document.createElement('a')
      a.href = downloadUrl
      a.download = filePath.split('/').pop() || 'download'
      document.body.appendChild(a)
      a.click()
      a.remove()

      window.URL.revokeObjectURL(downloadUrl)
    } catch { }
  }

  const getCrossSellData = async () => {
    const res = await fetch(
      `${API_URL}cross-sells?pagination=false&leadId=${leadId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'Application/Json',
          Authorization: `Bearer ${token}`
        }
      }
    )
    const result = await res.json()
    setCrossSellData(result?.data?.docs)
  }

  const handleBtnClick = btn => {
    setActiveBtn(btn)
  }

  return (
    <Fragment>
      <PageHeader
        pageName='LEAD DETAILS'
        breadcrump1='Home'
        breadcrump2='Lead Details'
        link='/dashboard'
      />
      <div className='pl-5 pr-3'>
        <Container fluid>
          <Row className='mt-4'>
            {activeBtn === 'Agreement' ? (
              ''
            ) : (
              <Col md={3}>
                <Card className='p-2'>
                  <CardBody className='border-bottom'>
                    <h4 className='text-slate-600'>
                      {leadDetails?.leadJourneyName}
                    </h4>
                    <p className='mt-3'>
                      Amount: Rs{' '}
                      {Number(
                        leadDetails?.productRequirements?.proposedDealAmount ||
                        0
                      ).toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}
                    </p>

                    <p className='mt-3'>
                      Close Date:{' '}
                      {new Date(
                        leadDetails?.enquiryDetails?.tentativeClosureDate
                      ).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric'
                      }) === 'Invalid Date'
                        ? '-'
                        : new Date(
                          leadDetails?.enquiryDetails?.tentativeClosureDate
                        ).toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric'
                        })}
                    </p>
                    <p className='mt-3'>
                      Sales Order Number:{' '}
                      {leadDetails?.salesOrder?.salesOrderNumber || 'NA'}
                    </p>
                  </CardBody>
                  <CardBody className='border-bottom'>
                    <h5 className='text-slate-600'>Lead Summary</h5>
                    <span>
                      <label className='form-label'>
                        <strong className='text-slate-600'>Owner</strong>
                      </label>
                      <p>{leadDetails?.leadOwner?.name}</p>
                    </span>
                    <span>
                      <label className='form-label'>
                        <strong className='text-slate-600'>Company</strong>
                      </label>
                      <p>{leadDetails?.client?.companyName}</p>
                    </span>
                    <span>
                      <label className='form-label'>
                        <strong className='text-slate-600'>Type of Sale</strong>
                      </label>
                      <p>{leadDetails?.productRequirements?.typeOfSale}</p>
                    </span>
                    <span>
                      <label className='form-label'>
                        <strong className='text-slate-600'>
                          Nature of Sale
                        </strong>
                      </label>
                      <p>{leadDetails?.productRequirements?.natureOfSale}</p>
                    </span>
                    <span>
                      <label className='form-label'>
                        <strong className='text-slate-600'>
                          Business Line
                        </strong>
                      </label>
                      <p>{leadDetails?.businessLine?.name}</p>
                    </span>
                  </CardBody>
                </Card>
              </Col>
            )}

            <Col md={activeBtn === 'Agreement' ? 12 : 9}>
              <Card>
                <CardBody>
                  <div className='d-flex'>
                    <Link
                      className={`client-activities ${activeBtn === 'Capture Details'
                        ? 'active no-underline'
                        : 'text-dark no-underline'
                        } p-1 col-md-3 text-center`}
                    >
                      <span onClick={() => handleBtnClick('Capture Details')}>
                        Known Universe
                      </span>
                    </Link>
                    <Link
                      className={`client-activities ${activeBtn === 'Update Platform'
                        ? 'active no-underline'
                        : 'text-dark no-underline'
                        } p-1 col-md-3 text-center`}
                    >
                      <span onClick={() => handleBtnClick('Update Platform')}>
                        Update Platform
                      </span>
                    </Link>
                    <Link
                      className={`client-activities ${activeBtn === 'line-items'
                        ? 'active no-underline'
                        : 'text-dark no-underline'
                        } p-1 col-md-3 text-center`}
                    >
                      <span onClick={() => handleBtnClick('line-items')}>
                        Line Items
                      </span>
                    </Link>
                    <Link
                      className={`client-activities ${activeBtn === 'Agreement'
                        ? 'active no-underline'
                        : 'text-dark no-underline'
                        } p-1 col-md-3 text-center`}
                    >
                      <span onClick={() => handleBtnClick('Agreement')}>
                        Sales Order
                      </span>
                    </Link>
                  </div>
                </CardBody>
              </Card>
              <TabContent activeTab={activeBtn}>
                <TabPane tabId='Capture Details'>
                  <Card className='mt-3'>
                    <CardBody>
                      <Row>
                        <h4>Client Details</h4>
                        <hr></hr>
                        <Col md={4}>
                          <label className='form-label'>
                            <strong>Company Name</strong>
                          </label>
                          <p>{leadDetails?.client?.companyName || '-'}</p>
                        </Col>
                        <Col md={4}>
                          <label className='form-label'>
                            <strong>Type of Organisation</strong>
                          </label>
                          <p>{leadDetails?.client?.organizationType || '-'}</p>
                        </Col>
                        <Col md={4}>
                          {leadDetails?.client?.isGSTRegistered === true ? (
                            <Fragment>
                              <label className='form-label'>
                                <strong>GSTIN</strong>
                              </label>
                              <p>{leadDetails?.client?.gstNumber || '-'}</p>
                            </Fragment>
                          ) : (
                            <Fragment>
                              <label className='form-label'>
                                <strong>PAN</strong>
                              </label>
                              <p>{leadDetails?.client?.panNumber || '-'}</p>
                            </Fragment>
                          )}
                        </Col>
                      </Row>
                      <Row>
                        <h4>
                          Product Requirements{' '}
                          {leadDetails.leadStatus === 'pending' &&
                            leadDetails.productRequirements.status === 'done' &&
                            userDetails?.role !== 'super_admin' &&
                            userDetails?.role !== 'admin' ? (
                            editProductRequirement === true ? (
                              <FontAwesomeIcon
                                className='text-danger ms-2 mb-1 text-sm'
                                onClick={() => setEditProductRequirement(false)}
                                icon={faXmark}
                              />
                            ) : (
                              <FontAwesomeIcon
                                className='text-warning ms-2 mb-1 text-sm'
                                onClick={() => setEditProductRequirement(true)}
                                icon={faPenToSquare}
                              />
                            )
                          ) : (
                            ''
                          )}
                        </h4>
                        <hr></hr>
                        {editProductRequirement === true ? (
                          <EditProdReq
                            id={leadDetails.id}
                            info={leadDetails.productRequirements}
                          />
                        ) : (
                          <Fragment>
                            <Col md={3}>
                              <label className='form-label'>
                                <strong>Type of Sale</strong>
                              </label>
                              <p>
                                {leadDetails?.productRequirements?.typeOfSale ||
                                  '-'}
                              </p>
                            </Col>
                            <Col md={3}>
                              <label className='form-label'>
                                <strong>Nature of Sale</strong>
                              </label>
                              <p>
                                {leadDetails?.productRequirements
                                  ?.natureOfSale || '-'}
                              </p>
                            </Col>
                            <Col md={3}>
                              <label className='form-label'>
                                <strong>Industry</strong>
                              </label>
                              <p>
                                {leadDetails?.productRequirements?.industry ||
                                  '-'}
                              </p>
                            </Col>
                            <Col md={3}>
                              <label className='form-label'>
                                <strong>Proposed Deal Amount</strong>
                              </label>
                              <p>
                                Rs{' '}
                                {
                                  leadDetails?.productRequirements
                                    ?.proposedDealAmount
                                }
                              </p>
                            </Col>

                            <Col md={3}>
                              <label className='form-label'>
                                <strong>Enquiry Details</strong>
                              </label>
                              <p>
                                {leadDetails?.productRequirements
                                  ?.enquiryDetails || '-'}
                              </p>
                            </Col>
                            <Col md={3}>
                              <label className='form-label'>
                                <strong>Lead Source</strong>
                              </label>
                              <p>
                                {leadDetails?.productRequirements?.leadSource ||
                                  '-'}
                              </p>
                            </Col>
                            <Col md={3}>
                              <label className='form-label'>
                                <strong>Description</strong>
                              </label>
                              <p>
                                {leadDetails?.productRequirements
                                  ?.description || '-'}
                              </p>
                            </Col>
                          </Fragment>
                        )}
                      </Row>
                      <Row>
                        <h4>
                          Enquiry Details{' '}
                          {leadDetails.leadStatus === 'pending' &&
                            leadDetails.enquiryDetails.status === 'done' &&
                            userDetails?.role !== 'super_admin' &&
                            userDetails?.role !== 'admin' ? (
                            editEnquiryDetails === true ? (
                              <FontAwesomeIcon
                                className='text-danger ms-2 mb-1 text-sm'
                                onClick={() => setEditEnquiryDetails(false)}
                                icon={faXmark}
                              />
                            ) : (
                              <FontAwesomeIcon
                                className='text-warning ms-2 mb-1 text-sm'
                                onClick={() => setEditEnquiryDetails(true)}
                                icon={faPenToSquare}
                              />
                            )
                          ) : (
                            ''
                          )}
                        </h4>
                        <hr></hr>
                        {editEnquiryDetails === true ? (
                          <EditEnquiryDetails
                            id={leadDetails?.id}
                            info={leadDetails?.enquiryDetails}
                          />
                        ) : (
                          <Fragment>
                            <Col md={3}>
                              <label className='form-label'>
                                <strong>Project Type</strong>
                              </label>
                              <p>
                                {leadDetails?.enquiryDetails?.projectType ||
                                  '-'}
                              </p>
                            </Col>
                            <Col md={3}>
                              <label className='form-label'>
                                <strong>Established Contact </strong>
                              </label>
                              <p>
                                {leadDetails?.enquiryDetails
                                  ?.contactEstablished === true
                                  ? 'Yes'
                                  : leadDetails?.enquiryDetails
                                    ?.contactEstablished === false
                                    ? 'No'
                                    : '-'}
                              </p>
                            </Col>
                            <Col md={3}>
                              <label className='form-label'>
                                <strong>Information Received</strong>
                              </label>
                              <p>
                                {leadDetails?.enquiryDetails
                                  ?.informationReceived === true
                                  ? 'Yes'
                                  : leadDetails?.enquiryDetails
                                    ?.informationReceived === false
                                    ? 'No'
                                    : '-'}
                              </p>
                            </Col>
                            <Col md={3}>
                              <label className='form-label'>
                                <strong>Further Information</strong>
                              </label>
                              <p>
                                {leadDetails?.enquiryDetails
                                  ?.furtherInformation || '-'}
                              </p>
                            </Col>
                            <Col md={6}>
                              <label className='form-label'>
                                <strong>Identified User</strong>
                              </label>
                              <p>
                                {leadDetails?.enquiryDetails?.userIdentified ===
                                  true
                                  ? 'Yes'
                                  : leadDetails?.enquiryDetails
                                    ?.userIdentified === false
                                    ? 'No'
                                    : '-'}
                              </p>
                            </Col>

                            <Col md={6}>
                              <label className='form-label'>
                                <strong>Any Past Meeting</strong>
                              </label>
                              <p>
                                {leadDetails?.enquiryDetails?.anyPastMeeting ===
                                  true
                                  ? 'Yes'
                                  : leadDetails?.enquiryDetails
                                    ?.anyPastMeeting === false
                                    ? 'No'
                                    : '-'}
                              </p>
                            </Col>
                            {leadDetails?.enquiryDetails?.anyPastMeeting ===
                              true
                              ? leadDetails?.enquiryDetails?.meetingDetails?.map(
                                (data, index) => (
                                  <React.Fragment key={index}>
                                    <h5>
                                      <strong>
                                        Meeting Details {index + 1}
                                      </strong>
                                    </h5>
                                    <Col md={6}>
                                      <label className='form-label'>
                                        <strong>Meeting Date</strong>
                                      </label>
                                      <p>
                                        {new Date(
                                          data?.date
                                        ).toLocaleDateString('en-GB', {
                                          day: '2-digit',
                                          month: 'short',
                                          year: 'numeric'
                                        }) === 'Invalid Date'
                                          ? '-'
                                          : new Date(
                                            data?.date
                                          ).toLocaleDateString('en-GB', {
                                            day: '2-digit',
                                            month: 'short',
                                            year: 'numeric'
                                          })}
                                      </p>
                                    </Col>
                                    <Col md={6}>
                                      <label className='form-label'>
                                        <strong>Meeting Notes</strong>
                                      </label>
                                      <p>{data?.notes || '-'}</p>
                                    </Col>
                                  </React.Fragment>
                                )
                              )
                              : ''}

                            <Col md={3}>
                              <label className='form-label'>
                                <strong>Tentative Closure Date</strong>
                              </label>
                              <p>
                                {new Date(
                                  leadDetails?.enquiryDetails?.tentativeClosureDate
                                ).toLocaleDateString('en-GB', {
                                  day: '2-digit',
                                  month: 'short',
                                  year: 'numeric'
                                }) === 'Invalid Date'
                                  ? '-'
                                  : new Date(
                                    leadDetails?.enquiryDetails?.tentativeClosureDate
                                  ).toLocaleDateString('en-GB', {
                                    day: '2-digit',
                                    month: 'short',
                                    year: 'numeric'
                                  })}
                              </p>
                            </Col>
                            <Col md={3}>
                              <label className='form-label'>
                                <strong>Need Identified</strong>
                              </label>
                              <p>
                                {leadDetails?.enquiryDetails?.needIdentified ===
                                  true
                                  ? 'Yes'
                                  : leadDetails?.enquiryDetails
                                    ?.needIdentified === false
                                    ? 'No'
                                    : '-'}
                              </p>
                            </Col>
                          </Fragment>
                        )}
                      </Row>
                    </CardBody>
                  </Card>
                </TabPane>
                <TabPane tabId='Update Platform'>
                  <Card className='mt-3'>
                    <CardBody>
                      <Row>
                        <h4>
                          Marketing Platform{' '}
                          {leadDetails?.leadStatus === 'pending' &&
                            leadDetails?.marketingPlatform?.status === 'done' &&
                            userDetails?.role !== 'super_admin' &&
                            userDetails?.role !== 'admin' ? (
                            editMarketingPlatform === true ? (
                              <FontAwesomeIcon
                                className='text-danger ms-2 mb-1 text-sm'
                                onClick={() => setEditMarkeingPlatform(false)}
                                icon={faXmark}
                              />
                            ) : (
                              <FontAwesomeIcon
                                className='text-warning ms-2 mb-1 text-sm'
                                onClick={() => setEditMarkeingPlatform(true)}
                                icon={faPenToSquare}
                              />
                            )
                          ) : (
                            ''
                          )}
                        </h4>
                        <hr></hr>
                        {editMarketingPlatform === true ? (
                          <EditMarketingPlatform
                            id={leadDetails.id}
                            info={leadDetails.marketingPlatform}
                          />
                        ) : (
                          <Fragment>
                            <Col md={12}>
                              <label className='form-label'>
                                <strong>Identified Influencer</strong>
                              </label>
                              <p>
                                {leadDetails?.marketingPlatform
                                  ?.influencerIdentified === true
                                  ? 'Yes'
                                  : leadDetails?.marketingPlatform
                                    ?.influencerIdentified === false
                                    ? 'No'
                                    : '-'}
                              </p>
                            </Col>
                            {leadDetails?.marketingPlatform
                              ?.influencerIdentified === true ? (
                              <Fragment>
                                <Col md={3}>
                                  <label className='form-label'>
                                    <strong>Influencer Name</strong>
                                  </label>
                                  <p>
                                    {
                                      leadDetails?.marketingPlatform
                                        ?.contactPerson?.name
                                    }
                                  </p>
                                </Col>
                                <Col md={3}>
                                  <label className='form-label'>
                                    <strong>Influencer Phone</strong>
                                  </label>
                                  <p>
                                    {
                                      leadDetails?.marketingPlatform
                                        ?.contactPerson?.phoneNumber
                                    }
                                  </p>
                                </Col>
                                <Col md={3}>
                                  <label className='form-label'>
                                    <strong>Influencer Email</strong>
                                  </label>
                                  <p>
                                    {
                                      leadDetails?.marketingPlatform
                                        ?.contactPerson?.email
                                    }
                                  </p>
                                </Col>
                                <Col md={3}>
                                  <label className='form-label'>
                                    <strong>Influencer Designation</strong>
                                  </label>
                                  <p>
                                    {
                                      leadDetails?.marketingPlatform
                                        ?.contactPerson?.designation
                                    }
                                  </p>
                                </Col>
                              </Fragment>
                            ) : (
                              ''
                            )}

                            <Col md={4}>
                              <label className='form-label'>
                                <strong>Equipment Confirmed</strong>
                              </label>
                              <p>
                                {leadDetails?.marketingPlatform
                                  ?.equipmentConfirmed === true
                                  ? 'Yes'
                                  : leadDetails?.marketingPlatform
                                    ?.equipmentConfirmed === false
                                    ? 'No'
                                    : '-'}
                              </p>
                            </Col>
                            <Col md={4}>
                              <label className='form-label'>
                                <strong>Submitted 1st Offer</strong>
                              </label>
                              <p>
                                {leadDetails?.marketingPlatform
                                  ?.submittedFirstOffer === true
                                  ? 'Yes'
                                  : leadDetails?.marketingPlatform
                                    ?.submittedFirstOffer === true
                                    ? 'No'
                                    : '-'}
                              </p>
                            </Col>
                            <Col md={4}>
                              <label className='form-label'>
                                <strong>Compititors</strong>
                              </label>
                              <p>
                                {leadDetails?.marketingPlatform?.competitors ||
                                  '-'}
                              </p>
                            </Col>
                            <Col md={6}>
                              <label className='form-label'>
                                <strong>
                                  Statutory Requirements Identified
                                </strong>
                              </label>
                              <p>
                                {leadDetails?.marketingPlatform
                                  ?.statutoryRequirementsIdentified === true
                                  ? 'Yes'
                                  : leadDetails?.marketingPlatform
                                    ?.statutoryRequirementsIdentified ===
                                    false
                                    ? 'No'
                                    : '-'}
                              </p>
                            </Col>
                            <Col md={6}>
                              <label className='form-label'>
                                <strong>Any Past Meeting</strong>
                              </label>
                              <p>
                                {leadDetails?.enquiryDetails?.anyPastMeeting ===
                                  true
                                  ? 'Yes'
                                  : leadDetails?.enquiryDetails
                                    ?.anyPastMeeting === false
                                    ? 'No'
                                    : '-'}
                              </p>
                            </Col>
                            {leadDetails?.marketingPlatform?.meetingDetails?.map(
                              (data, index) => {
                                return (
                                  <>
                                    <h5>
                                      <strong>
                                        Meeting Details {index + 1}
                                      </strong>
                                    </h5>
                                    <Col md={6}>
                                      <label className='form-label'>
                                        <strong>Meeting Date</strong>
                                      </label>
                                      <p>
                                        {new Date(
                                          data?.date
                                        ).toLocaleDateString('en-GB', {
                                          day: '2-digit',
                                          month: 'short',
                                          year: 'numeric'
                                        }) === 'Invalid Date'
                                          ? '-'
                                          : new Date(
                                            data?.date
                                          ).toLocaleDateString('en-GB', {
                                            day: '2-digit',
                                            month: 'short',
                                            year: 'numeric'
                                          })}
                                      </p>
                                    </Col>
                                    <Col md={6}>
                                      <label className='form-label'>
                                        <strong>Meeting Notes</strong>
                                      </label>
                                      <p>{data?.notes || '-'}</p>
                                    </Col>
                                  </>
                                )
                              }
                            )}
                          </Fragment>
                        )}
                      </Row>
                      <Row>
                        <h4>
                          Working Platform{' '}
                          {leadDetails.leadStatus === 'pending' &&
                            leadDetails.workingPlatform.status === 'done' &&
                            userDetails?.role !== 'super_admin' &&
                            userDetails?.role !== 'admin' ? (
                            editWorkingPlatform === true ? (
                              <FontAwesomeIcon
                                className='text-danger ms-2 mb-1 text-sm'
                                onClick={() => setEditWorkingPlatform(false)}
                                icon={faXmark}
                              />
                            ) : (
                              <FontAwesomeIcon
                                className='text-warning ms-2 mb-1 text-sm'
                                onClick={() => setEditWorkingPlatform(true)}
                                icon={faPenToSquare}
                              />
                            )
                          ) : (
                            ''
                          )}
                        </h4>
                        <hr></hr>
                        {editWorkingPlatform === true ? (
                          <EditWorkingPlatform
                            id={leadDetails.id}
                            info={leadDetails.workingPlatform}
                          />
                        ) : (
                          <Fragment>
                            <Col md={12}>
                              <label className='form-label'>
                                <strong>
                                  Is End User Different For Customer
                                </strong>
                              </label>
                              <p>
                                {leadDetails?.workingPlatform
                                  ?.differentEndUser === true
                                  ? 'Yes'
                                  : leadDetails?.workingPlatform
                                    ?.differentEndUser === false
                                    ? 'No'
                                    : '-'}
                              </p>
                            </Col>
                            {leadDetails?.workingPlatform?.differentEndUser ===
                              true ? (
                              <Fragment>
                                <Col md={3}>
                                  <label className='form-label'>
                                    <strong>User Name</strong>
                                  </label>
                                  <p>
                                    {
                                      leadDetails?.workingPlatform
                                        ?.contactPerson?.name
                                    }
                                  </p>
                                </Col>
                                <Col md={3}>
                                  <label className='form-label'>
                                    <strong>User Email</strong>
                                  </label>
                                  <p>
                                    {
                                      leadDetails?.workingPlatform
                                        ?.contactPerson?.email
                                    }
                                  </p>
                                </Col>
                                <Col md={3}>
                                  <label className='form-label'>
                                    <strong>User Phone</strong>
                                  </label>
                                  <p>
                                    {
                                      leadDetails?.workingPlatform
                                        ?.contactPerson?.phoneNumber
                                    }
                                  </p>
                                </Col>
                                <Col md={3}>
                                  <label className='form-label'>
                                    <strong>User Designation</strong>
                                  </label>
                                  <p>
                                    {
                                      leadDetails?.workingPlatform
                                        ?.contactPerson?.designation
                                    }
                                  </p>
                                </Col>
                              </Fragment>
                            ) : (
                              ''
                            )}

                            <Col md={6}>
                              <label className='form-label'>
                                <strong>
                                  Technical and Commercial Discussion Completed?
                                </strong>
                              </label>
                              <p>
                                {leadDetails?.workingPlatform
                                  ?.technicalAndCommercialDiscussionCompleted ===
                                  true
                                  ? 'Yes'
                                  : leadDetails?.workingPlatform
                                    ?.technicalAndCommercialDiscussionCompleted ===
                                    false
                                    ? 'No'
                                    : '-'}
                              </p>
                            </Col>
                            <Col md={6}>
                              <label className='form-label'>
                                <strong>Commercial Proposal Submitted?</strong>
                              </label>
                              <p>
                                {leadDetails?.workingPlatform
                                  ?.commercialProposalSubmitted === true
                                  ? 'Yes'
                                  : leadDetails?.workingPlatform
                                    ?.commercialProposalSubmitted === false
                                    ? 'No'
                                    : '-'}
                              </p>
                            </Col>
                            <Col md={6}>
                              <label className='form-label'>
                                <strong>
                                  First Round of Commercial negotiation started?
                                </strong>
                              </label>
                              <p>
                                {leadDetails?.workingPlatform
                                  ?.firstRoundCommercialNegotiationStarted ===
                                  true
                                  ? 'Yes'
                                  : leadDetails?.workingPlatform
                                    ?.firstRoundCommercialNegotiationStarted ===
                                    false
                                    ? 'No'
                                    : '-'}
                              </p>
                            </Col>
                            <Col md={6}>
                              <label className='form-label'>
                                <strong>Approved Finance Description</strong>
                              </label>
                              <p>
                                {leadDetails?.workingPlatform
                                  ?.approvedFinanceDescription || '-'}
                              </p>
                            </Col>
                            <Col md={3}>
                              <label className='form-label'>
                                <strong>Installation Visit Done?</strong>
                              </label>
                              <p>
                                {leadDetails?.workingPlatform
                                  ?.installationVisitDone === true
                                  ? 'Yes'
                                  : leadDetails?.workingPlatform
                                    ?.installationVisitDone === false
                                    ? 'No'
                                    : '-'}
                              </p>
                            </Col>
                            <Col md={3}>
                              <label className='form-label'>
                                <strong>Date and Time of Visit?</strong>
                              </label>
                              <p>
                                {leadDetails?.workingPlatform?.dateOfVisit?.substring(
                                  0,
                                  10
                                ) || '-'}
                              </p>
                            </Col>
                            <Col md={3}>
                              <label className='form-label'>
                                <strong>Visit Note</strong>
                              </label>
                              <p>
                                {leadDetails?.workingPlatform?.visitNotes ||
                                  '-'}
                              </p>
                            </Col>
                          </Fragment>
                        )}
                      </Row>
                      <Row>
                        <h4>
                          Buying Platform{' '}
                          {leadDetails.leadStatus === 'pending' &&
                            leadDetails.buyingPlatform.status === 'done' &&
                            userDetails?.role !== 'super_admin' &&
                            userDetails?.role !== 'admin' ? (
                            editBuyingPlatform === true ? (
                              <FontAwesomeIcon
                                className='text-danger ms-2 mb-1 text-sm'
                                onClick={() => setEditBuyingPlatform(false)}
                                icon={faXmark}
                              />
                            ) : (
                              <FontAwesomeIcon
                                className='text-warning ms-2 mb-1 text-sm'
                                onClick={() => setEditBuyingPlatform(true)}
                                icon={faPenToSquare}
                              />
                            )
                          ) : (
                            ''
                          )}
                        </h4>
                        <hr></hr>
                        {editBuyingPlatform === true ? (
                          <EditBuyingPlatform
                            id={leadDetails.id}
                            info={leadDetails.buyingPlatform}
                          />
                        ) : (
                          <Fragment>
                            <Col md={6}>
                              <label className='form-label'>
                                <strong>Stage Update</strong>
                              </label>
                              <p>{leadDetails?.buyingPlatform?.stage || '-'}</p>
                            </Col>
                            <Col md={6}>
                              <label className='form-label'>
                                <strong>Lost or Won against whom? </strong>
                              </label>
                              <p>
                                {leadDetails?.buyingPlatform
                                  ?.lostOrWonAgainst || '-'}
                              </p>
                            </Col>
                            <Col md={12}>
                              <label className='form-label'>
                                <strong>Reason for Lost/Drop</strong>
                              </label>
                              <p>
                                {leadDetails?.buyingPlatform?.closingReason ||
                                  '-'}
                              </p>
                            </Col>
                          </Fragment>
                        )}
                      </Row>
                    </CardBody>
                  </Card>
                </TabPane>
                <TabPane tabId='line-items'>
                  <Card className='mt-3'>
                    <CardBody>
                      <Table>
                        <thead>
                          <tr>
                            <th>Product Line</th>
                            <th>Model</th>
                            <th>Amount</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {crossSellData.map((data, index) => {
                            return (
                              <tr key={index}>
                                <td>{data.productLine.productLineName}</td>
                                <td>{data.model.modelName}</td>
                                <td>{data.value}</td>
                                <td>
                                  {data.status === 'added' ? (
                                    <span className='text-green-500'>IN</span>
                                  ) : (
                                    <span className='text-red-500'>OUT</span>
                                  )}
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </Table>
                    </CardBody>
                  </Card>
                </TabPane>
                <TabPane tabId='Agreement'>
                  <Accordion open={openSO} toggle={toggleSO}>
                    {salesOrderData
                      .map((order, idx, filteredArray) => {
                        // Check if all line items are fully invoiced
                        const isFullyInvoiced = order?.lineItems?.every(
                          item => item.quantity === (item.invoiceQuantity - item.crnQty)
                        )

                        return (
                          <AccordionItem key={order._id}>
                            <AccordionHeader targetId={order._id}>
                              <div className='d-flex justify-content-between align-items-center w-100'>
                                <span>
                                  {`Version ${idx + 1} | ${new Date(
                                    order?.createdAt
                                  ).toLocaleDateString('en-GB', {
                                    day: '2-digit',
                                    month: 'short',
                                    year: 'numeric'
                                  })}`}
                                  {' | '}
                                  <span
                                    className={
                                      order?.status === 'rejected'
                                        ? 'text-danger fw-bold'
                                        : order?.status === 'pending'
                                          ? 'text-primary fw-bold'
                                          : 'text-success fw-bold'
                                    }
                                  >
                                    {order?.status !== 'pending'
                                      ? `${order?.approvedByManager?.name} (${order?.approvedByManager?.role.toUpperCase()}) | ${order?.approvedByCommercialManager?.name ?? order?.rejectedBy?.name ?? ''
                                        } (${order?.approvedByCommercialManager?.role.toUpperCase()}) ${order?.status === 'closed' ? `| ${order?.status}` : ''}`.trim()
                                      : order?.status.toUpperCase()}
                                  </span>
                                  {isFullyInvoiced && (
                                    <>
                                      {' | '}
                                      <span className='text-success fw-bold'>
                                        Invoiced and Closed
                                      </span>
                                    </>
                                  )}
                                </span>

                                <div className='d-flex align-items-center gap-2'>
                                  {userDetails?.role === 'commercial_manager' && (
                                    <button
                                      type='button'
                                      className='btn btn-sm btn-outline-success py-0 px-2'
                                      title='Create Proforma Invoice'
                                      onClick={e => {
                                        e.stopPropagation()
                                        setProformaOrder(order)
                                        setProformaModal(true)
                                      }}
                                    >
                                      Proforma
                                    </button>
                                  )}
                                  {/* SO PDF – visible to all */}
                                  <FontAwesomeIcon
                                    icon={faPrint}
                                    className='text-primary cursor-pointer ms-2'
                                    title='Download SO PDF'
                                    onClick={e => {
                                      e.stopPropagation()
                                      handleDownloadPDF(order)
                                    }}
                                  />
                                  {/* PI PDF – commercial_manager only */}
                                  {userDetails?.role === 'commercial_manager' && (
                                    <FontAwesomeIcon
                                      icon={faDownload}
                                      className='text-success cursor-pointer ms-1 me-2'
                                      title='Download Proforma Invoice PDF'
                                      onClick={e => {
                                        e.stopPropagation()
                                        handleDownloadProformaPDF(order)
                                      }}
                                    />
                                  )}
                                </div>
                              </div>
                            </AccordionHeader>

                            <AccordionBody accordionId={order._id}>
                              {editSalesOrderPlatform === true ? (
                                <EditSalesOrder id={order?.id} info={order} />
                              ) : (
                                <div
                                  ref={el => (pdfRefs.current[order._id] = el)}
                                >
                                  <div
                                    className='hidden justify-center items-center mb-4'
                                    id={`pdf-logo-${order._id}`}
                                  >
                                    <img
                                      src={Logo}
                                      alt='Company Logo'
                                      className='w-48 mb-4'
                                    />
                                  </div>

                                  {order?.status === 'rejected' ? (
                                    <Row>
                                      <Col md={12}>
                                        <h6 className='text-danger text-center'>
                                          {order?.reasonForRejection}
                                        </h6>
                                      </Col>
                                    </Row>
                                  ) : (
                                    ''
                                  )}

                                  <Row>
                                    <Col md={4}>
                                      <label className='form-label'>
                                        <strong>Sales Order Number</strong>
                                      </label>
                                      <p>{order?.salesOrderNumber || '-'}</p>
                                    </Col>
                                    <Col md={4}>
                                      <label className='form-label'>
                                        <strong>Business Line</strong>
                                      </label>
                                      <p>{order?.businessLine?.name || '-'}</p>
                                    </Col>
                                    <Col md={4}>
                                      <label className='form-label'>
                                        <strong>Lead No</strong>
                                      </label>
                                      <p>{order?.lead?.leadId || '-'}</p>
                                    </Col>
                                    <Col md={4}>
                                      <label className='form-label'>
                                        <strong>Sales Executive</strong>
                                      </label>
                                      <p>{order?.lead?.leadOwner?.name || '-'}</p>
                                    </Col>
                                    <Col md={4}>
                                      <label className='form-label'>
                                        <strong>Customer Name</strong>
                                      </label>
                                      <p>
                                        {order?.lead?.client?.companyName || '-'}
                                      </p>
                                    </Col>
                                    <Col md={4}>
                                      <label className='form-label'>
                                        <strong>Date of SO</strong>
                                      </label>
                                      <p>
                                        {new Date(
                                          order?.createdAt
                                        ).toLocaleDateString('en-GB', {
                                          day: '2-digit',
                                          month: 'short',
                                          year: 'numeric'
                                        })}
                                      </p>
                                    </Col>
                                    <Col md={4}>
                                      <label className='form-label'>
                                        <strong>Zero Date Delivery</strong>
                                      </label>
                                      <p>
                                        {new Date(
                                          order?.zeroDateOfDelivery
                                        ).toLocaleDateString('en-GB', {
                                          day: '2-digit',
                                          month: 'short',
                                          year: 'numeric'
                                        })}
                                      </p>
                                    </Col>

                                    {order?.isPOAvailable === true ? (
                                      <>
                                        <Col md={4}>
                                          <label className='form-label'>
                                            <strong>Customer PO Number</strong>
                                          </label>
                                          <p>
                                            <Link
                                              className='text-dark no-underline'
                                              onClick={() =>
                                                downloadPo(order?.POFilePath)
                                              }
                                            >
                                              {order?.customerPONumber || '-'}
                                            </Link>
                                          </p>
                                        </Col>

                                        <Col md={4}>
                                          <label className='form-label'>
                                            <strong>Customer PO Date</strong>
                                          </label>
                                          <p>
                                            {new Date(
                                              order?.customerPODate
                                            ).toLocaleDateString('en-GB', {
                                              day: '2-digit',
                                              month: 'short',
                                              year: 'numeric'
                                            })}
                                          </p>
                                        </Col>
                                      </>
                                    ) : (
                                      <Col md={8}>
                                        <label className='form-label'>
                                          <strong>Po Details</strong>
                                        </label>
                                        <p>{order?.PODetails}</p>
                                      </Col>
                                    )}

                                    <Col md={4}>
                                      <label className='form-label'>
                                        <strong>GSPL GSTIN</strong>
                                      </label>
                                      <p>{order?.gsplGSTNumber || '-'}</p>
                                    </Col>
                                    <Col md={4}>
                                      <label className='form-label'>
                                        <strong>Consultant (If Any)</strong>
                                      </label>
                                      <p>{order?.consultant || '-'}</p>
                                    </Col>
                                    <Col md={4}>
                                      <label className='form-label'>
                                        <strong>Currency of Transaction</strong>
                                      </label>
                                      <p>{order?.currencyOfTransaction || '-'}</p>
                                    </Col>
                                    <Col md={4}>
                                      <label className='form-label'>
                                        <strong>
                                          Warranty Period from date of
                                          commissioning
                                        </strong>
                                      </label>
                                      <p>{order?.warrantyPeriod || '-'} Months</p>
                                    </Col>
                                    <Col md={4}>
                                      <label className='form-label'>
                                        <strong>
                                          Warranty Period from date of last supply
                                        </strong>
                                      </label>
                                      <p>{order?.warrantyTerms || '-'} Months</p>
                                    </Col>
                                    <Col md={4}>
                                      <label className='form-label'>
                                        <strong>Billing Address</strong>
                                      </label>
                                      <p>{order?.billingAddress || '-'}</p>
                                    </Col>
                                    <Col md={4}>
                                      <label className='form-label'>
                                        <strong>Shipping Address</strong>
                                      </label>
                                      <p>{order?.shippingAddress || '-'}</p>
                                    </Col>
                                    <Col md={4}>
                                      <label className='form-label'>
                                        <strong>Remarks</strong>
                                      </label>
                                      <p>{order?.remarks || '-'}</p>
                                    </Col>
                                  </Row>

                                  {/* Line Items Table with editable LP + Update button */}
                                  <div className='avoid-page-break'>
                                    <Table className='so-table' responsive>
                                      <thead>
                                        <tr>
                                          <th>SI</th>
                                          <th>Name</th>
                                          <th>Part Code</th>
                                          <th>UOM</th>
                                          <th>Qty</th>
                                          <th>DI Qty</th>
                                          <th>INV Qty</th>
                                          <th>CRN Qty</th>
                                          <th>Std. Lead Time</th>
                                          <th>Date</th>
                                          <th>LP</th>
                                          <th>Discount</th>
                                          <th>Rate Per Unit</th>
                                          <th>Order Value</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {order?.lineItems?.map((data, index) => (
                                          <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{data?.model?.modelName}</td>
                                            <td>{data?.model?.partCode}</td>
                                            <td>{data?.model?.uom}</td>
                                            <td>{data?.quantity}</td>
                                            <td>{data?.diQuantity}</td>
                                            <td>{data?.invoiceQuantity}</td>
                                            <td>{data?.crnQty || 0}</td>
                                            <td>{data?.standardLeadTime}</td>
                                            <td>
                                              {new Date(
                                                data?.committedDeliveryDate
                                              ).toLocaleDateString('en-GB', {
                                                day: '2-digit',
                                                month: 'short',
                                                year: 'numeric'
                                              })}
                                            </td>

                                            {userDetails?.role ===
                                              'super_admin' ||
                                              userDetails?.role === 'admin' ? (
                                              <td>
                                                <input
                                                  type='number'
                                                  step='0.01'
                                                  className='form-control form-control-sm'
                                                  onWheel={e => e.target.blur()}
                                                  value={
                                                    lpChanges[order._id]?.[
                                                      data._id
                                                    ] !== undefined
                                                      ? lpChanges[order._id][
                                                      data._id
                                                      ]
                                                      : data?.listPrice ?? ''
                                                  }
                                                  onChange={e =>
                                                    handleLPChange(
                                                      order._id,
                                                      data._id,
                                                      e.target.value
                                                    )
                                                  }
                                                />
                                              </td>
                                            ) : (
                                              <td>{data?.listPrice}</td>
                                            )}

                                            <td>
                                              {(data?.discount || 0).toFixed(2)}%
                                            </td>
                                            <td>
                                              {(data?.rate || 0).toFixed(2)}
                                            </td>
                                            <td>
                                              {(data?.value || 0).toFixed(2)}
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                      <tfoot>
                                        <tr>
                                          <td
                                            colSpan={13}
                                            className='text-end fw-bold'
                                          >
                                            Total Sales Order Value
                                          </td>
                                          <td className='fw-bold'>
                                            {order?.currencyOfTransaction
                                              ? `${order.currencyOfTransaction} `
                                              : ''}
                                            {(
                                              order?.lineItems?.reduce(
                                                (acc, item) => acc + (item.value || 0),
                                                0
                                              ) || 0
                                            ).toFixed(2)}
                                          </td>
                                        </tr>
                                      </tfoot>
                                    </Table>
                                    {userDetails?.role === 'super_admin' ||
                                      userDetails?.role === 'admin' ? (
                                      <div className='d-flex justify-content-end mt-2'>
                                        <button
                                          type='button'
                                          className='btn btn-sm btn-primary'
                                          onClick={() => updateSOTemp(order)}
                                        >
                                          Update
                                        </button>
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>


                                  <Row className='mt-3'>
                                    <Col md={8}>
                                      <div className='avoid-page-break'>
                                        <Table className='so-table'>
                                          <thead>
                                            <tr>
                                              <th>Payment Terms</th>
                                              <th>Percentage</th>
                                              <th>Amount</th>
                                              <th>Other Details</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {order?.paymentTerms?.map(
                                              (data, index) => {
                                                const totalValue =
                                                  order?.lineItems?.reduce(
                                                    (acc, item) =>
                                                      acc + (item.value || 0),
                                                    0
                                                  )
                                                const computedPercentage =
                                                  totalValue
                                                    ? (
                                                      (data?.amount /
                                                        totalValue) *
                                                      100
                                                    ).toFixed(2)
                                                    : 0

                                                return (
                                                  <tr key={index}>
                                                    <td>{data?.type || '-'}</td>
                                                    <td>{computedPercentage}%</td>
                                                    <td>
                                                      {(
                                                        data?.amount || 0
                                                      ).toFixed(2)}
                                                    </td>
                                                    <td>{data?.otherDetails || ''}</td>
                                                  </tr>
                                                )
                                              }
                                            )}
                                          </tbody>
                                        </Table>

                                        <Table className='so-table'>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <strong>Price Basis:</strong>
                                              </td>
                                              <td>{order?.priceBasis || '-'}</td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <strong>
                                                  Responsibility of
                                                  transportation:
                                                </strong>
                                              </td>
                                              <td>
                                                {order?.responsibilityOfTransportation ||
                                                  '-'}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <strong>
                                                  Type of Transaction:
                                                </strong>
                                              </td>
                                              <td>
                                                {order?.typeOfTransaction || '-'}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <strong>GST Details:</strong>
                                              </td>
                                              <td>GST extra as applicable</td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <strong>
                                                  Bank Guarantee Details:
                                                </strong>
                                              </td>
                                              <td>
                                                {order?.bankGuaranteeDetails ||
                                                  '-'}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </Table>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              )}

                              {/* Show Edit button based on user role and order status */}
                              <div className='d-flex justify-content-between align-items-center mt-2'>
                                <div>
                                  {/* Close SO button — commercial_manager only, approved orders, not fully invoiced */}
                                  {(userDetails?.role === 'commercial_manager' || userDetails?.role === 'super_admin') &&
                                    order?.status === 'approved by commercial manager' &&
                                    !isFullyInvoiced && (
                                      <button
                                        className='btn btn-danger btn-sm'
                                        onClick={() => {
                                          setClosingOrder(order)
                                          setClosingReason('')
                                          setCloseSOModal(true)
                                        }}
                                      >
                                        Close SO
                                      </button>
                                    )}
                                </div>
                                <div>
                                  {((userDetails?.role === 'manager' &&
                                    idx === filteredArray.length - 1 && order?.status === 'approved by commercial manager') ||
                                    (userDetails?.role === 'executive' &&
                                      order?.status === 'rejected') ||
                                    (userDetails?.role === 'manager' &&
                                      order?.status === 'rejected')) &&
                                    !isFullyInvoiced ? (
                                    <button
                                      onClick={() =>
                                        setEditSalesOrderPlatform(
                                          !editSalesOrderPlatform
                                        )
                                      }
                                      className='btn add-btn text-white'
                                    >
                                      {editSalesOrderPlatform === false
                                        ? 'Edit'
                                        : 'Back'}
                                    </button>
                                  ) : (
                                    ''
                                  )}
                                </div>
                              </div>
                            </AccordionBody>
                          </AccordionItem>
                        )
                      })}
                  </Accordion>

                  {/* Proforma Invoice Modal */}
                  <ProformaInvoiceModal
                    isOpen={proformaModal}
                    toggle={() => setProformaModal(false)}
                    salesOrder={proformaOrder}
                    onSuccess={() => {
                      setProformaModal(false)
                      window.alert('Proforma Invoice created successfully!')
                    }}
                  />

                  {/* Close Sales Order Confirmation Modal */}
                  <Modal
                    isOpen={closeSOModal}
                    toggle={() => !closingLoading && setCloseSOModal(false)}
                    centered
                  >
                    <ModalHeader toggle={() => !closingLoading && setCloseSOModal(false)}>
                      Close Sales Order
                    </ModalHeader>
                    <ModalBody>
                      <p className='mb-2'>
                        You are about to close Sales Order{' '}
                        <strong>{closingOrder?.salesOrderNumber}</strong>. This
                        action cannot be undone.
                      </p>
                      <label className='form-label fw-semibold'>
                        Closing Reason <span className='text-danger'>*</span>
                      </label>
                      <textarea
                        className='form-control'
                        rows={3}
                        placeholder='Enter reason for closing this sales order...'
                        value={closingReason}
                        onChange={e => setClosingReason(e.target.value)}
                        disabled={closingLoading}
                      />
                    </ModalBody>
                    <ModalFooter>
                      <button
                        className='btn btn-danger'
                        onClick={handleCloseSalesOrder}
                        disabled={closingLoading}
                      >
                        {closingLoading ? 'Closing...' : 'Confirm Close'}
                      </button>
                      <button
                        className='btn btn-secondary'
                        onClick={() => setCloseSOModal(false)}
                        disabled={closingLoading}
                      >
                        Cancel
                      </button>
                    </ModalFooter>
                  </Modal>
                </TabPane>
              </TabContent>
            </Col>
          </Row>
        </Container>
      </div>
    </Fragment>
  )
}

export default LeadProfile
